import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ComingSoon from "./pages/ComingSoon";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            background: "#1A1A1A",
            color: "#fff",
            border: "1px solid #2f2f2f",
            fontFamily: "Work Sans, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
